


























import IconPoint from "@/common/components/icons/IconPoint.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import store from "@/general/store";

@Component({
  components: {
    IconPoint
  },
  filters: {
    addComma(value: any) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
  },
  store: store
})
export default class PointNotation extends Vue {
  @Prop({
    type: Number,
    default: 24
  })
  fontSize!: number;

  @Prop({
    type: [Boolean, Number],
    default: false
  })
  iconSize!: number | boolean;

  @Prop({
    type: [Boolean, Number],
    default: false
  })
  iconSpSize!: number | boolean;

  @Prop({
    type: Number,
    required: true
  })
  point!: number;

  @Prop({
    type: [Boolean, String],
    default: "#000"
  })
  pointColor!: string | boolean;

  @Prop({
    type: Boolean,
    default: true
  })
  sign!: boolean;

  @Prop({
    type: [Boolean, String],
    default: true
  })
  signIsExists!: string | boolean;

  @Prop({
    type: [Object]
  })
  unit!: any;

  @Prop({
    type: String,
    default: ""
  })
  point_logo: string;

  get getSignData() {
    const sign = this.sign;
    const signClassName = sign ? "plus" : "minus";
    const signLabel = sign ? "+" : "-";

    return { signClassName, signLabel };
  }

  get unitProp() {
    return this.unit;
  }
  getUnit() {
    if (commons?.OrgPageSpecific?.point_name) {
      return commons?.OrgPageSpecific?.point_name;
    }
    return commons?.unit?.point;
  }

  get fontStyle() {
    return { color: this.pointColor, fontSize: `${this.fontSize / 16}rem` };
  }
}
